import { render, staticRenderFns } from "./OrderLink.vue?vue&type=template&id=07f53f4f&scoped=true&"
import script from "./OrderLink.vue?vue&type=script&lang=js&"
export * from "./OrderLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f53f4f",
  null
  
)

export default component.exports